// Adds transition classes to notification, fades to 0 opacity and then hides from dom on transition finish
function fadeOutNotification(form) {
    let notifications = form.querySelectorAll('.ff-form-errors, .ff-form-success');

    for (let notification of notifications) {
        notification.classList.add('transition-opacity', 'duration-500', 'delay-[15000ms]', 'flex', 'items-center');

        setTimeout(() => {
            notification.classList.add('opacity-0');
        }, 50);

        notification.addEventListener('transitionend', event => {
            notification.classList.add('hidden');
        }, { once: true });
    }
}

export function handleFreeformError(form) {
    let notifications = form.querySelectorAll('.ff-form-errors, .ff-form-success');
    let submitButton = form.querySelector('button[data-freeform-action="submit"]');
    let prevButton = form.querySelector('button[data-freeform-action="back"]');

    for (let notification of notifications) {
        if (prevButton) {
            prevButton.closest('.freeform-column').insertBefore(notification, prevButton);
            fadeOutNotification(form);
        } else {
            submitButton.closest('.freeform-column').insertBefore(notification, submitButton);
            fadeOutNotification(form);
        }
    }
}

window.addEventListener('load', event => {

    // Function that pushes GA data through to datalayer for GTM
    // ...additional datalayer data can be added at time of form submission
    function gtmPush(event, formId, additional = {}) {
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                event: event,
                formName: formId,
                ...additional
            });
        }
    }

    // Function that sets field values based on cookies etc.
    function setFormValues(form) {

        // Array of form fields and the new value that should be assigned to that field
        let formFields = [
            {
                handle: form.utmSource,
                newValue: Cookies.get('utm_source')
            },
            {
                handle: form.utmMedium,
                newValue: Cookies.get('utm_medium')
            },
            {
                handle: form.utmCampaign,
                newValue: Cookies.get('utm_campaign')
            },
            {
                handle: form.utmContent,
                newValue: Cookies.get('utm_content')
            },
            {
                handle: form.gaclientid,
                newValue: Cookies.get('_ga')?.slice(6)
            },
            {
                handle: form.gatrackid,
                newValue: typeof google_tag_manager === 'object' ? Object.keys(google_tag_manager).filter((key) => key.indexOf('G-') === 0) : ''
            },
            {
                handle: form.gclid,
                newValue: Cookies.get('ff_gclid')
            },
            {
                handle: form.pageUrl,
                newValue: window.location
            },
            {
                handle: form.pageTitle,
                newValue: form.dataset.pageTitle
            }
        ]

        // Assign form fields new values if they exist
        for (let field of formFields) {
            if (field.handle && field.newValue) {
                field.handle.value = field.newValue;
            }
        }
    }

    function filterNonLatinCharacters(e) {
        const inputField = e.target;
        const cursorPos = inputField.selectionStart;
        const initialLength = inputField.value.length;
        const filtered = inputField.value.replace(/[^\x20-\x7F]+/g, "");
        const filteredLength = filtered.length;
        const numOfRemovedChars = initialLength - filteredLength;
        inputField.value = filtered;
        const currentCursorPos = cursorPos - numOfRemovedChars
        inputField.selectionStart = currentCursorPos;
        inputField.selectionEnd = currentCursorPos;
    }

    function setupInputFields() {
        const inputFields = document.querySelectorAll('input[type=text],textarea');
        inputFields?.forEach((inputField) => {
            inputField.addEventListener('input', filterNonLatinCharacters);
        });
    }

    function changePostcodeType(countryField) {
        const postcodeField = countryField.closest('form').querySelector('input[name="postcode"]');
        if (postcodeField) {
            const country = countryField.value;
            if (!country || country.trim().length === 0 || country === 'Australia') {
                postcodeField.type = 'number';
            } else {
                postcodeField.type = 'text';
            }
        }
    }

    function changePostcodeTypeFromChangeEvent(e) {
        const countryField = e.target;
        changePostcodeType(countryField);
    }

    function setupCountryFields() {
        const countryFields = document.querySelectorAll('select[name="country"]');
        countryFields?.forEach((countryField) => {
            changePostcodeType(countryField);
        });
        countryFields?.forEach((countryField) => {
            countryField.addEventListener('change', changePostcodeTypeFromChangeEvent);
        });
    }

    // Freeform functions
    let forms = document.querySelectorAll('form');

    for (let form of forms) {
        const formId = form.id;

        // Override Freeform default error/success message
        // Commented as should be set on form via cms, but could be useful for a dynamic message on a reusable form
        // freeform.setOption('errorBannerMessage', 'Error!');
        // freeform.setOption('successBannerMessage', 'Success!');

        // Runs when freeform has attempted a submission
        form.addEventListener('freeform-on-submit', function (event) {

            // Calls function to set dynamic field values
            setFormValues(form);
        });

        // Runs after ajax submit
        form.addEventListener('freeform-ajax-after-submit', function(event) {
            // Override error/success notification position on ajax submission
            handleFreeformError(form);
        });

        // Runs before ajax submit
        form.addEventListener('freeform-ajax-before-submit', function(event) {
            // Adds any additional requirements to GA data
            // payload = form data after 'freeform-on-submit' has run
            // payload.get('field handle') = associated value of that field handle
            const payload = event.data;

            form.dataLayerSubmission = {
                gaFormName: payload.get('gaformname'),
            };
        });

        // Runs after successful ajax submission
        form.addEventListener('freeform-ajax-success', function(event) {
            let formContainer = form.closest('div[data-form-complete]');

            if (formContainer) {
                formContainer.dataset.formComplete = 'true';
                setTimeout(() => {
                    formContainer.dataset.formComplete = 'false';
                }, 10000);
            }

            // Pushes GA data through to datalayer
            gtmPush('formSubmitted', formId, {enquiryFormData: form.dataLayerSubmission});
        });
    }

    setupInputFields();
    setupCountryFields();

    // Fix for the broken sprig search when navigating back to a page... why we using a broken search?
    const searchInput = document.querySelector('section#searchPanel input');
    if (searchInput && searchInput.value.length) {
        const event = new KeyboardEvent('keyup', { key: 'Enter', code: 'Enter', which: 13, keyCode: 13, });
        searchInput.dispatchEvent(event);
    }
});